var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "hidden relative lg:flex items-center bg-indigo-200 overflow-visible rounded-sm h-48 w-full"
  }, [_vm._m(0), _vm._v(" "), _c('illustration', {
    staticClass: "hidden xl:block absolute right-5 xl:right-10 w-60 xl:w-72",
    attrs: {
      "name": "cartographie"
    }
  })], 1), _vm._v(" "), _vm.allowed ? _c('div', [_c('div', {
    staticClass: "flex mb-5 lg:mt-10 lg:mb-10 items-center"
  }, [_vm.$can('cartography_collective_export') ? _c('action-button', {
    staticClass: "mr-10 tour_carto_print",
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-gray-900",
      "bg-color": "bg-indigo-300",
      "bg-color-square": "bg-indigo-200",
      "icon-color": "text-indigo-600",
      "libelle": "Imprimer",
      "icon": "printer"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col"
  }, [_c('div', {
    staticClass: "relative align-middle min-w-full shadow sm:rounded-lg border-b border-gray-200 bg-white pt-15 px-10 xl:pt-0 xl:px-15 pb-10 min-h-halfscreen overflow-x-auto"
  }, [_c('router-view')], 1)])]) : _c('page-not-allowed')], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "px-12"
  }, [_c('p', {
    staticClass: "text-4xl text-gray-900"
  }, [_vm._v("Cartographies collectives")]), _vm._v(" "), _c('p', {
    staticClass: "mt-2 text-base font-light leading-4 2xl:leading-5 text-gray-600 xl:pr-72"
  }, [_vm._v("\n        Retrouvez ici différentes données sur vos carnets de parcours."), _c('br'), _vm._v("\n        Vous pouvez enregistrer manuellement chaque cartographie et faire des\n        comparaisons par date\n      ")])]);

}]

export { render, staticRenderFns }